import React from "react";

const HistoryItemShimmer = () => {
    return (
        <>
            <div className="history-item-shimmer d-flex align-items-center mb-3 justify-content-center">
                <div className="avatar-shimmer" />
                <div className="content-shimmer">
                    <div className="line-shimmer short" />
                    <div className="line-shimmer long" />
                </div>
            </div>
            <style jsx>{`
        .history-item-shimmer {
          display: flex;
          align-items: center;
          margin-bottom: 16px;
          position: relative;
          overflow: hidden;
        }
        .avatar-shimmer {
          width: 40px;
          height: 40px;
          border-radius: 50%;
          background-color: #e0e0e0;
          margin-right: 12px;
          flex-shrink: 0;
        }
        .content-shimmer {
          flex: 1;
        }
        .line-shimmer {
          height: 12px;
          background-color: #e0e0e0;
          border-radius: 4px;
          margin-bottom: 8px;
        }
        .line-shimmer.short {
          width: 30%;
        }
        .line-shimmer.long {
          width: 70%;
        }
        /* Shimmer effect */
        .history-item-shimmer::after {
          content: "";
          position: absolute;
          top: 0;
          left: -150px;
          width: 150px;
          height: 100%;
          background: linear-gradient(
            90deg,
            transparent,
            rgba(255, 255, 255, 0.4),
            transparent
          );
          animation: shimmer 1.5s infinite;
        }
        @keyframes shimmer {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(300%);
          }
        }
      `}</style>
        </>
    );
};

export default HistoryItemShimmer;
